;
VLW.CustomSelect = class extends VLW.classBase {
	constructor(elt) {
		super();
		this.elt          = elt;
		let wrapper       = document.createElement('div');
		wrapper.innerHTML = '<div class="customSelect-styled"></div><div class="custom_SVG"><div class="__ico"></div></div>';
		wrapper.classList.add("customSelect");
		wrap(this.elt, wrapper);

		this.style           = wrapper.querySelector(".customSelect-styled");
		let idSelected       = (getIndex(this.elt.querySelector("option[selected]")) + 1) || 0;
		this.style.innerHTML = this.elt.querySelector("option:nth-child(" + idSelected + ")").innerHTML;
		this.ul              = document.createElement('ul');
		this.ul.classList.add("customSelect-options");
		let lis = "";
		[...this.elt.querySelectorAll("option")].forEach((e) => {
			lis += "<li value='" + e.getAttribute("value") + "'>" + e.innerHTML + "</li>";
		});
		this.ul.innerHTML = lis;
		insertAfter(this.ul, this.style);
		this.style.addEventListener("click", this.onClickStyle);
		document.addEventListener("click", this.onClickBody);
		[...this.ul.querySelectorAll("li")].forEach((e) => {
			e.addEventListener("click", this.onClickLi);
		});
	}
	onClickLi(e) {
		this.style.innerHTML   = e.currentTarget.innerHTML;
		this.elt.selectedIndex = getIndex(e.currentTarget);
		this.style.parentNode.classList.remove("active");
		this.elt.dispatchEvent(new Event('change'));
	}
	onClickBody() {
		this.style.parentNode.classList.remove("active");
	}

	onClickStyle(e) {
		e.stopPropagation();
		this.style.parentNode.classList.toggle("active");
	}
	instanceClean(){
		this.style.removeEventListener("click", this.onClickStyle);
		document.removeEventListener("click", this.onClickBody);
		[...this.ul.querySelectorAll("li")].forEach((e) => {
			e.removeEventListener("click", this.onClickLi);
		});
	}
};